import { OKRsBodyTemplate } from '@/components/templates/datatable';
import { useProductRoadmap } from '@/domain/products/hooks';
import { type Product, type ProductRoadmap } from '@/domain/products/types';
import { RoadmapTable } from '@/features/roadmap/components';
import { toDateString } from '@/utils/datetime';
import { Column } from 'primereact/column';

const releaseDateTemplate = (rowData: ProductRoadmap) => {
  return rowData.version?.releaseDate ? toDateString(rowData.version.releaseDate) : '';
};

const statusBodyTemplate = (rowData: ProductRoadmap) =>
  rowData.status ? `${rowData.status?.name} (${Math.round(rowData.percentComplete)}%)` : '';

interface RoadmapTabProps {
  product: Product;
}

const RoadmapTab = ({ product }: RoadmapTabProps) => {
  const { data = [], isLoading, refetch } = useProductRoadmap(product.idProduct);

  const onSaveDeleteRoadmap = async () => {
    await refetch();
  };

  return (
    <RoadmapTable
      isLoading={isLoading}
      roadMaps={data.map((r) => ({ ...r, product }))}
      onDeleteCallback={onSaveDeleteRoadmap}
      onSaveCallback={onSaveDeleteRoadmap}
    >
      <Column field="type.name" header="Type" sortable />
      <Column field="item" header="Item" sortable />
      <Column field="version.name" header="Version" sortable />
      <Column field="okrs.name" header="Business Impact" sortable body={OKRsBodyTemplate} />
      <Column field="version.releaseDate" header="Date" body={releaseDateTemplate} sortable />
      <Column field="percentComplete" header="Status" sortable body={statusBodyTemplate} />
    </RoadmapTable>
  );
};

export default RoadmapTab;
